import { render, staticRenderFns } from "./CVTypeCareerOverseas.vue?vue&type=template&id=99c2e706"
import script from "./CVTypeCareerOverseas.vue?vue&type=script&lang=js"
export * from "./CVTypeCareerOverseas.vue?vue&type=script&lang=js"
import style0 from "./CVTypeCareerOverseas.vue?vue&type=style&index=0&id=99c2e706&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports